<template>
  <v-snackbar
    v-model="show"
    :timeout="timeoutGetter"
    :color="colorGetter"
    top>
    {{ msgGetter }}
    <v-btn
      v-if="closableGetter"
      icon
      @click="acknowledge">
      <v-icon>close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "root",
  computed: {
    ...mapGetters({
      closableGetter: "closable",
      colorGetter: "color",
      msgGetter: "msg",
      showGetter: "show",
      timeoutGetter: "timeout"
    }),
    show: {
      get () {
        return this.showGetter;
      },
      set (newValue) {
        if (newValue === false) {
          this.acknowledge();
        }
      }
    }
  },
  methods: { ...mapActions(["acknowledge"]) }
};
</script>



// WEBPACK FOOTER //
// src/components/Notification.vue